import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getfinancial } from "../actions/financialActions";

const Financial=React.memo((props)=> {
  const dispatch = useDispatch();

  const financialList = useSelector((state) => state.financialList);
  const { financials, loading, error } = financialList;

  // var min = new Date().getFullYear();
  // var max = new Date().getFullYear() + 3;
  // var rec = "[";
  // for (var i = min; i < max; i++) {
  //     rec += `{year:'${i}'},`;
  // }
  // rec = rec.replace(/,\s*$/, "");
  // rec += "]";

  const [checkk, setCheckk] = useState([]);
  const handleChange = (e) => {
    let { value, checked } = e.target;
    let tempcheck = checkk;
    if (checked) {
      tempcheck.push({ name: value });
    } else {
      tempcheck = tempcheck.filter((ck) => ck.name !== value);
    }

    let str = "";
    for (var i = 0; i < tempcheck.length; i++) {
      str += tempcheck[i].name + ",";
    }
    str = str.replace(/,\s*$/, "");
    setCheckk(tempcheck);
    props.handleAchange(str);
  };

  useEffect(() => {
    if (!financials) {
      dispatch(getfinancial());
    }
    // console.log(financials)
  }, [financials]);
  return (
    <>
      {loading ? (
        <>loading...</>
      ) : (
        <>
          {financials ? (
            financials.map((financia, u) => (
              <div className="form-check" key={u}>
                <label
                  className="form-check-label"
                  for={financia.FinancialSource}
                >
                  <input
                    type="checkbox"
                    className="form-check-input"
                    value={financia.FinancialSource}
                    onChange={(e) => handleChange(e)}
                  />
                  {financia.FinancialSource}
                </label>
              </div>
            ))
          ) : (
            <>
              <option>Loading...</option>
            </>
          )}
        </>
      )}
    </>
  );
})

export default Financial;
